import { Validator } from 'vee-validate'
import './validations'

function load () {
  const dictionary = {
    pt: {
      messages: {
        required: field => `O campo ${field} é obrigatório.`,
        email: field => `O campo ${field} precisa ser um email válido.`,
        min: (field, length) => `O campo ${field} precisa ter no mínimo ${length} caracteres.`,
        max: (field, length) => `O campo ${field} precisa ter no máximo ${length} caracteres.`,
        min_value: (field, value) => `O valor de ${field} deve ser maior ou igual a ${value}.`,
        max_value: (field, value) => `O valor de ${field} não pode ser maior do que ${value}.`,
        size: (field, value) => `O tamanho do arquivo não pode ultrapassar ${value}.`,
        numeric: field => `O campo ${field} precisa ser um número válido.`,
        digits: (field, length) => `O campo ${field} precisa ter ${length} dígitos.`,
        confirmed: field => `A confirmação de ${field} está incorreta.`,
        image: field => `O arquivo precisa ser uma imagem.`,
        unique: field => `Este ${field} já existe.`,
        length: (field, length) => `O campo ${field} precisa ter ${length} caracteres.`,
        cnpj: field => 'Formato de CNPJ inválido.',
        cpf: field => 'Formato de CPF inválido.',
        cep: field => 'Formato de CEP inválido.'
      },
      attributes: {
        name: 'nome',
        registration: 'número da matrícula',
        birthdate: 'data de nascimento',
        idCard: 'RG',
        issuingOrgan: 'órgão emissor',
        issuingDate: 'data de emissão',
        documentCountry: 'país de origem',
        documentState: 'estado de origem',
        cpf: 'CPF',
        cnpj: 'CNPJ',
        fatherName: 'nome do pai',
        motherName: 'nome da mãe',
        schooling: 'escolaridade',
        schoolingStatus: 'status da escolaridade',
        addressZipcode: 'CEP',
        addressStreet: 'logradouro',
        addressNumber: 'número ou lote',
        addressComplement: 'complemento',
        addressNeighborhood: 'bairro',
        addressCity: 'cidade',
        addressState: 'estado',
        telephone: 'telefone',
        cellphone: 'celular',
        department: 'setor',
        role: 'cargo',
        manpower: 'tipo de mão de obra',
        rtf: 'RTF',
        externalService: 'tipo de serviço externo',
        eSocial: 'categoria eSocial',
        hiringStatus: 'status de contratação',
        entryDate: 'data de entrada',
        leaveDate: 'data de saída',
        backDate: 'data de volta',
        experienceDays: 'dias de experiência',
        observations: 'observações',
        password: 'senha',
        password_confirmation: 'confirmação de senha',
        currentPassword: 'senha atual',
        socialName: 'razão social',
        fantasyName: 'nome fantasia',
        companyOwner: 'contato',
        primaryEmail: 'email primário',
        secondaryEmail: 'email secundário',
        stateRegistration: 'inscrição estadual',
        branchline: 'ramal'
      }
    }
  }

  Validator.localize(dictionary)
  Validator.localize('pt')
}

export default { load }



// WEBPACK FOOTER //
// ./src/config/validator.js